module.exports = __webpack_public_path__ + "static/media/L.1bcd405b.jpg";